import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form, withFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Ellipsis } from 'react-spinners-css';

import Alert from '../../../common/Alert';

import ProfileInput from '../../../form/ProfileInput';

const mapPropsToValues = () => ({
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: '',
});

const mapPropsToStatus = () => ({});

const validationSchema = yup.object().shape({
  currentPassword: yup.string().required(),
  newPassword: yup.string().required(),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Passwords must match')
    .required(),
});

const getErrorMessage = error => {
  if (error.response && error.response.data && error.response.data.errorMessage) {
    return error.response.data.errorMessage;
  }

  return 'Unknown server error';
};

const handleSubmit = async (values, bag) => {
  bag.setSubmitting(true);

  try {
    await axios.put('/api/v1/profile/change-password', values, {
      headers: {
        Authorization: `Bearer ${bag.props.token}`,
      },
    });

    bag.resetForm();
    bag.setStatus({ isSuccess: true, message: 'Password has been successfully changed' });
  } catch (e) {
    bag.resetForm();
    bag.setStatus({ isError: true, message: getErrorMessage(e) });
  }
  bag.setSubmitting(false);
};

const ChangePasswordForm = props => {
  const isMobile = props.isMobile || false;

  return (
    <Form>
      {!props.isSubmitting && props.status.isSuccess && (
        <Alert message={props.status.message} isSuccess isSmall={isMobile} isClosable={true} />
      )}
      {!props.isSubmitting && props.status.isError && (
        <Alert message={props.status.message} isError isSmall={isMobile} isClosable={true} />
      )}
      <Field
        type="password"
        name="currentPassword"
        label="Current password"
        isMobile={isMobile}
        component={ProfileInput}
        disabled={props.isSubmitting}
      />
      <Field
        type="password"
        name="newPassword"
        label="New password"
        isMobile={isMobile}
        component={ProfileInput}
        disabled={props.isSubmitting}
      />
      <Field
        type="password"
        name="confirmNewPassword"
        label="Confirm new password"
        isMobile={isMobile}
        component={ProfileInput}
        disabled={props.isSubmitting}
      />
      <button
        type="submit"
        className="gradient-button mt-10px"
        disabled={props.isSubmitting}
        style={{ width: '150px' }}
      >
        {!props.isSubmitting && <span>Save changes</span>}
        {props.isSubmitting && <Ellipsis color="white" size={40} />}
      </button>
    </Form>
  );
};

ChangePasswordForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  status: PropTypes.shape({
    isSuccess: PropTypes.bool,
    isError: PropTypes.bool,
    message: PropTypes.string,
  }),
  errors: PropTypes.shape({
    summary: PropTypes.string,
    currentPassword: PropTypes.string,
    newPassword: PropTypes.string,
    confirmNewPassword: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
};

export default compose(
  connect(({ token }) => ({ token })),
  withFormik({ mapPropsToValues, mapPropsToStatus, validationSchema, handleSubmit }),
)(ChangePasswordForm);
